import { ActionIcon, Divider, Flex, Text } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

type ChatHeaderProps = {
  onHideChat?: () => void;
};

export default function ChatHeader({ onHideChat }: ChatHeaderProps) {
  return (
    <>
      <Flex px={'md'} py={'xxs'} justify={'space-between'} align={'center'}>
        <Text size={'xl'} fw={600} style={{ zIndex: 2 }}>
          Siesta AI
        </Text>
        <ActionIcon variant={'subtle'} size={'sm'} onClick={onHideChat}>
          <IconX size={20} color={'black'} />
        </ActionIcon>
      </Flex>
      <Divider />
    </>
  );
}
